import React from "react";
import { Card } from '@mui/material'
import { texts } from "../../general/texts";
import colors from "../../colors";
import { makeStyles } from '@mui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useNavigate } from "react-router-dom";
import { ReactComponent as WalletIcon } from "../../../icons/Wallet.svg";
import { ReactComponent as MobilePaymentIcon } from "../../../icons/Mobile Payment.svg";
import { ReactComponent as FriendGroupIcon } from "../../../icons/FriendGroup.svg";

const ReferedByFriend = () => {
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const navigate = useNavigate()

    const useStyles = makeStyles({
        container: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        infoCard: {
            display: 'flex',
            flexDirection: isSmallScreen ? 'column-reverse' : 'row',
            padding: "15px",
            width: isSmallScreen ? "90vw" : "915px",
            height: isSmallScreen ? "80vh" : "370px",
            borderRadius: "14px",
            textAlign: isSmallScreen ? "center" : "left",
            borderRadius: "15px",
            marginTop: "80px",
            '& h1': {
                marginBottom: "30px",
                fontSize: isSmallScreen ? '25px' : '28px',
                fontWeight: 700
            },
            '& h3': {
                marginBottom: "10px",
            },
            '& h4': {
                margin: "0",
            },
            '& p': {
                margin: "0",
                marginBottom: "10px",
            }
        },
        flexRow: {
            display: 'flex',
            flexDirection: 'row',
        },

        flexCol: {
            display: 'flex',
            flexDirection: 'column',
        },

        easyPayButton: {
            color: colors.white,
            background: "linear-gradient(321.73deg, #F0A13D 26.7%, #EF7A30 98.66%)",
            border: 'none',
            borderRadius: '10px',
            width: '300px',
            height: '42px',
            fontSize: '18px',
            marginTop: '50px',
            cursor: 'pointer'
        }
    });

    const classes = useStyles();

    return (
        <>
            <div className={classes.container}>
                <Card className={classes.infoCard}>
                    <div style={{ marginLeft: '15px' }}>
                        <h1 style={{ color: colors.orange }}>{texts['refered-friend-title']}</h1>
                        <h3 style={{ color: colors.orange, fontSize: '20px' }}>{texts['refered-friend-subtitle']}</h3>
                        <div className={classes.flexRow}>
                            <MobilePaymentIcon style={{ marginRight: 6, marginTop: 2 }} />
                            <div className={classes.flexCol}>
                                <h4 style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['refered-friend-p1']}</h4>
                                <p style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-substep2']}</p>
                            </div>
                        </div>
                        <div className={classes.flexRow}>
                            <WalletIcon style={{ marginRight: 6, marginTop: 2 }} />
                            <div className={classes.flexCol}>
                                <h4 style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['refered-friend-p2']}</h4>
                                <p style={{ color: colors.darkBlue, fontSize: '18px' }}>{texts['invite-friend-substep3']}</p>
                            </div>
                        </div>
                        <button onClick={() => navigate('/dashboard')} className={classes.easyPayButton}>{texts['button-topup-account']}</button>
                    </div>
                    <FriendGroupIcon width={isSmallScreen ? 400 : 506} height={318} style={{ marginTop: '40px' }} />
                </Card>
            </div>
        </>
    )
}
export default ReferedByFriend;
